import { render, staticRenderFns } from "./OrderUploadFile.vue?vue&type=template&id=3c106288&"
import script from "./OrderUploadFile.vue?vue&type=script&lang=ts&"
export * from "./OrderUploadFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports